<template>
  <Frontendlayout>
    <section class="hero_in general">
      <div class="wrapper">
        <div class="container">
          <h1 class="fadeInUp"><span></span>Choose Your Package</h1>
        </div>
      </div>
    </section>

    <div class="card your_properties" id="your_properties">
      <div class="card-body">
        <section class="pricing-section">
          <!--div class="sec-title text-center">
            <span class="title">Get Membership</span>
            <h2>Choose a Package</h2>
          </div-->
          <div class="outer-box">
            <div class="row">
              <!-- Pricing Block -->

              <div
                v-for="data in packageList"
                :key="data.id"
                class="pricing-block col-lg-4 col-md-4 col-sm-12"
               
              >
                <div class="inner-box">
                  <div class="icon-box">
                    <div class="icon-outer">
                      <i class="fa fa-paper-plane"></i>
                    </div>
                  </div>
                  <div class="price-box quill-editor">
                    <div class="title" style="text-transform: uppercase;">{{ data.package_name }}</div>
                    <h4 class="price">{{ data.amount }} INR/-</h4>
                    <hr />
                    <!-- <div
                      class="title"
                      v-for="pack in data.package_details"
                      :key="pack.id"
                    >
                      <span class="price"
                        >{{ pack.count }} {{ pack.service }}
                      </span>
                    </div> -->
                    <div
                      class="title">
                      <span class="price"
                        >Get Points {{ data.points }}
                      </span>
                    </div>

                  </div>
                  <div class="btn-box">
                    <button class="theme-btn" @click="packagePurchase(data.id)">
                      Buy Plan
                    </button>
                  </div>
                </div>
              </div>
              <!-- Pricing Block -->

              <div
                class="menu_fixed modal fade show"
                id="confirmModal"
                tabindex="-1"
                role="dialog"
                aria-labelledby="confirmModalLabel"
                aria-hidden="true"
                v-show="isModalVisible"
                @close="hideModal"
              >
                <div class="modal-dialog modal-dialog-centered" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="confirmModalLabel">
                        Confirm Purchase
                      </h5>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <h3>
                        You have chosen Package {{ package_name }}. Proceed to
                        make Payment of {{ package_price }}
                      </h3>
                    </div>
                    <div class="modal-footer">
                      <button class="theme-btn">Proceed To Payment</button>
                      <button class="theme-btn" @click="hideModal">
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /Bootstap Modal -->
            </div>
          </div>
        </section>
      </div>
    </div>
  </Frontendlayout>
</template>

<script>
import API from "@/services/index";
import Frontendlayout from "@/layouts/Frontendlayout.vue";
export default {
  data() {
    return {
      response: null,
      packageList: [],
      token: "Bearer " + localStorage.getItem("token"),
      // packageId: "",
      package_name: null,
      package_price: null,
      msg: null,
      classAlert: null,
      isModalVisible: false,
    };
  },

  beforeMount() {
    this.checkToken();
    this.getPackage();
  },

  methods: {
    checkToken() {
      const token = localStorage.getItem("token");
      // alert(token);
      if (token == null) {
        this.$router.push("/signin");
      }
    },
    getPackage() {
      API.get("packages/get_package", {
        headers: { Authorization: this.token },
      })
        .then((res) => {
          this.packageList = res.data.data;
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    showModal(response) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "bottom-right",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });

      this.$swal({
        title: response.messages,
        text: "Credits will be added in your account after you proceed ",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, Proceed to checkout",
        closeOnConfirm: false,
      }).then((isConfirm) => {
        console.log(isConfirm.isConfirmed);

        if (!isConfirm.isConfirmed) {
          Toast.fire({
            icon: "error",
            title: "Purchase Failed. Please try again",
          });
          this.$router.push("/packages");
          return false;
        } else {
          const form = new FormData();
          form.append("transaction_no", response.data.transaction_no);
          const token = "Bearer " + localStorage.getItem("token");

          API.post("/vendor/confirmpurchase", form, {
            headers: { Authorization: token },
          }).then((res) => {
            console.log(res.data.messages);
            if (res.data.status == 200) {
              Toast.fire({
                icon: "success",
                title: res.data.messages,
              });
              window.location.href = "/balance-credits";
            }
          });
        }
      });
    },
    hideModal() {
      this.isModalVisible = false;
    },
    packagePurchase(packageId) {
      //alert(packageId);
      const form = new FormData();
      form.append("package_id", packageId);
      const token = "Bearer " + localStorage.getItem("token");

      API.post("/vendor/save_vendor_purchase", form, {
        headers: { Authorization: token },
      })
        .then((res) => {
          console.log(res.data.messages);

          if (res.data.status == 200) {
            this.msg = res.data.messages;
            this.classAlert = "success";
            this.package_name = res.data.data.package_name;
            this.package_price = res.data.data.amount;
            // eslint-disable-next-line no-undef
            this.showModal(res.data);
          } else {
            this.msg = res.data.messages;
            this.classAlert = "danger";
          }
        })
        .catch((err) => {
          console.log(err);
          this.msg = err.response.data.messages.error;
          this.classAlert = "danger";
        });
      //axios
    },
  },
  components: {
    Frontendlayout,
  },
};
</script>

<style scoped>
.table-bordered > tbody > tr > th {
  font-size: 12px;
}
a,
a:hover,
a:focus,
a:active {
  text-decoration: none;
  outline: none;
}
a,
a:active,
a:focus {
  color: #333;
  text-decoration: none;
  transition-timing-function: ease-in-out;
  -ms-transition-timing-function: ease-in-out;
  -moz-transition-timing-function: ease-in-out;
  -webkit-transition-timing-function: ease-in-out;
  -o-transition-timing-function: ease-in-out;
  transition-duration: 0.2s;
  -ms-transition-duration: 0.2s;
  -moz-transition-duration: 0.2s;
  -webkit-transition-duration: 0.2s;
  -o-transition-duration: 0.2s;
}
ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
img {
  max-width: 100%;
  height: auto;
}
/*--blog----*/
.sec-title {
  position: relative;
  padding: 10px 0 35px;
}
.sec-title .title {
  position: relative;
  display: block;
  font-size: 16px;
  line-height: 1em;
  color: #ff8a01;
  font-weight: 500;
  color: #ed4e2a;
  text-transform: uppercase;
  letter-spacing: 5px;
  margin-bottom: 15px;
}
.sec-title h2 {
  position: relative;
  display: inline-block;
  font-size: 48px;
  line-height: 1.2em;
  color: #1e1f36;
  font-weight: 700;
}
.sec-title .text {
  position: relative;
  font-size: 16px;
  line-height: 28px;
  color: #888888;
  margin-top: 30px;
}
.sec-title.light h2,
.sec-title.light .title {
  color: #ffffff;
  -webkit-text-fill-color: inherit;
}

.pricing-section .outer-box {
  margin: 0 auto;
}
.pricing-section .row {
  margin: 0 -30px;
}
.pricing-block {
  position: relative;
  padding: 0 20px;
}
.pricing-block .inner-box {
  position: relative;
  background-color: #ffffff;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
  padding: 0 0 30px;
  margin: 0 auto;
  border-bottom: 20px solid #daa520;
}
.pricing-block .icon-box {
  position: relative;
  padding: 50px 30px 0;
  background-color: #daa520;
  text-align: center;
}
.pricing-block .icon-box:before {
  position: absolute;
  left: 0;
  bottom: 0;
  height: 75px;
  width: 100%;
  border-radius: 50% 50% 0 0;
  background-color: #ffffff;
  content: "";
}
.pricing-block .icon-box .icon-outer {
  position: relative;
  height: 150px;
  width: 150px;
  background-color: #ffffff;
  border-radius: 50%;
  margin: 0 auto;
  padding: 10px;
}
.pricing-block .icon-box i {
  position: relative;
  display: block;
  height: 130px;
  width: 130px;
  line-height: 120px;
  border: 5px solid #daa520;
  border-radius: 50%;
  font-size: 50px;
  color: #daa520;
  -webkit-transition: all 600ms ease;
  -ms-transition: all 600ms ease;
  -o-transition: all 600ms ease;
  -moz-transition: all 600ms ease;
  transition: all 600ms ease;
}
.pricing-block .inner-box:hover .icon-box i {
  transform: rotate(360deg);
}
.pricing-block .price-box {
  position: relative;
  text-align: center;
  padding: 10px 20px;
}
.pricing-block .title {
  position: relative;
  display: block;
  font-size: 24px;
  line-height: 1.2em;
  color: #222222;
  font-weight: 600;
}
.pricing-block .price {
  display: block;
  font-size: 30px;
  color: #daa520;
  font-weight: 700;
  color: #daa520;
}
.pricing-block .features {
  position: relative;
  max-width: 200px;
  margin: 0 auto 20px;
}
.pricing-block .features li {
  position: relative;
  display: block;
  font-size: 14px;
  line-height: 30px;
  color: #848484;
  font-weight: 500;
  padding: 5px 0;
  padding-left: 30px;
  border-bottom: 1px dashed #dddddd;
}
.pricing-block .features li:before {
  position: absolute;
  left: 0;
  top: 50%;
  font-size: 16px;
  color: #2bd40f;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
  content: "\f058";
  font-family: "Font Awesome 5 Free";
  margin-top: -8px;
}
.pricing-block .features li.false:before {
  color: #e1137b;
  content: "\f057";
}
.pricing-block .features li a {
  color: #848484;
}
.pricing-block .features li:last-child {
  border-bottom: 0;
}
.pricing-block .btn-box {
  position: relative;
  text-align: center;
}
.pricing-block .btn-box button {
  position: relative;
  display: inline-block;
  font-size: 14px;
  line-height: 25px;
  color: #ffffff;
  font-weight: 500;
  padding: 8px 30px;
  background-color: #daa520;
  border-radius: 10px;
  border-top: 2px solid transparent;
  border-left: 2px solid transparent;
  border-right: 2px solid transparent;
  border-bottom: 2px solid transparent;
  -webkit-transition: all 400ms ease;
  -moz-transition: all 400ms ease;
  -ms-transition: all 400ms ease;
  -o-transition: all 400ms ease;
  transition: all 300ms ease;
}
.pricing-block .btn-box button:hover {
  color: #ffffff;
}
.pricing-block .inner-box:hover .btn-box button {
  color: #daa520;
  background: none;
  border-radius: 0px;
  border-color: #daa520;
}
.pricing-block:nth-child(2) .icon-box i,
.pricing-block:nth-child(2) .inner-box {
  border-color: #c0c0c0;
}
.pricing-block:nth-child(2) .btn-box button,
.pricing-block:nth-child(2) .icon-box {
  background-color: #c0c0c0;
}
.pricing-block:nth-child(2) .inner-box:hover .btn-box button {
  color: #c0c0c0;
  background: none;
  border-radius: 0px;
  border-color: #c0c0c0;
}
.pricing-block:nth-child(2) .icon-box i,
.pricing-block:nth-child(2) .price {
  color: #c0c0c0;
}
.pricing-block:nth-child(3) .icon-box i,
.pricing-block:nth-child(3) .inner-box {
  border-color: #ff5733;
}
.pricing-block:nth-child(3) .btn-box button,
.pricing-block:nth-child(3) .icon-box {
  background-color: #ff5733;
}
.pricing-block:nth-child(3) .icon-box i,
.pricing-block:nth-child(3) .price {
  color: #ff5733;
}
.pricing-block:nth-child(3) .inner-box:hover .btn-box button {
  color: #ff5733;
  background: none;
  border-radius: 0px;
  border-color: #ff5733;
}
span.price {
  font-size: 18px !important;
}
@media only screen and (min-width: 768px) {
  .pricing-section {
    width: 890px;
    margin: 0 auto;
    position: relative;
    padding: 20px;
    overflow: hidden;
  }
}

@media only screen and (max-width: 767px) {
  .pricing-section {
    position: relative;
    padding: 20px;
    overflow: hidden;
  }
  .pricing-block {
    margin: 15px 0;
  }

  .pricing-section .row {
    margin: 0 -15px;
  }

  .sec-title h2 {
    font-size: 32px;
  }
}
</style>